export const DEFAULT_BRAND_PRIMARY_COLOUR = '#5260FF';

/** Normalize a six-digit hexadecimal colour for Appwrite Team preferences. */
export const normalizeBrandHexColour = (value: unknown): string | null => {
  if (typeof value !== 'string') return null;

  const trimmed = value.trim();
  const withHash = trimmed.startsWith('#') ? trimmed : `#${trimmed}`;
  return /^#[0-9a-f]{6}$/i.test(withHash) ? withHash.toUpperCase() : null;
};

export const getBrandHexColourError = (value: string): string | null => {
  if (!value.trim()) return 'Enter a primary brand colour.';
  return normalizeBrandHexColour(value)
    ? null
    : 'Use a six-digit hexadecimal colour, such as #5260FF.';
};
